import AddContentObjectContainer from '../../pages/AddContentObject/AddContentObjectContainer';
import EditMediaContainer from '../../pages/EditMedia/EditMediaContainer';

interface EditObjectContentModalProps {
  /**
   * Content object type name
   */
  contentTypeName: string;
  /**
   * Content object id
   */
  id: string;
  /**
   * Edit modal test id
   */
  testId?: string;
  /**
   * Should the form have switches for enabling fields
   */
  isPatchable?: boolean;
  /**
   * Function to call when the form is submitted
   */
  onSubmit: (data: any) => void;
}

/**
 * @emits FlotiqPlugins."flotiq.form.relation::after-submit"
 */
const EditObjectContentModal = ({
  contentTypeName,
  id,
  onSubmit,
  testId = '',
}: EditObjectContentModalProps) => {
  const isMedia = contentTypeName === '_media';

  return (
    <>
      {isMedia ? (
        <EditMediaContainer id={id} onSubmit={onSubmit} testId={testId} />
      ) : (
        <AddContentObjectContainer
          contentTypeName={contentTypeName}
          id={id}
          onSubmit={onSubmit}
          testId={testId}
        />
      )}
    </>
  );
};

export default EditObjectContentModal;
